export default {
  FOOTER_HEIGHT: 200,
  HEADER_HEIGHT: 200
};
